import "mediaelement";
import "mediaelement/src/js/languages/de";
import "mediaelement-plugins-custom-akme/dist/a11y/a11y-i18n";
import "mediaelement-plugins-custom-akme/dist/a11y/a11y";
import "mediaelement-plugins-custom-akme/dist/jump-forward/jump-forward";
import "mediaelement-plugins-custom-akme/dist/skip-back/skip-back";
import "mediaelement-plugins-custom-akme/dist/speed/speed";
import "bootstrap/js/dist/modal";

var AudioPlayer = (() => {

    class AMAudioPlayer {
        constructor(element) {
            this.element = element;
            const audioElement = this.element.querySelector("audio");
            this.settings = {
                mejs: {
                    features: [
                        "playpause",
                        "skipback",
                        "jumpforward",
                        "current",
                        "progress",
                        "duration",
                        "speed",
                        "volume",
                        "a11y",
                    ],
                    audioVolume: "vertical",
                    jumpForwardInterval: 15,
                    // todo: dictionary
                    jumpForwardText: audioElement.dataset.jumpForwardText,
                    skipBackInterval: 15,
                    // todo: dictionary
                    skipBackText: audioElement.dataset.skipBackText,
                    toggleCaptionsButtonWhenOnlyOne: true,
                    speeds: [
                        { name: '2x', value: '2.00' },
                        { name: '1.5x', value: '1.5' },
                        { name: '1.25x', value: '1.25' },
                        { name: '0.75x', value: '0.75' },
                        { name: '1x', value: '1.00' }
                    ],
                    speedText: audioElement.dataset.speedText,
                    defaultSpeed: '1.00',
                }
            };

            this.player = {
                mejs: null,
                audio: this.element.querySelector("audio"),
                captioncontrolsBtn: null,
                captioncontrolsInput: null,
                captions: null,
                modal: null,
                playBtn: null,
                suggestions: null,
                audioVolume: 'vertical',
            };

            this.displayAudio();
        }

        bindEvents() {
            var that = this;

            this.player.suggestions = this.player.suggestions || $(this.element).find(".audioPlayer__suggestions");

            this.player.mejs.node.addEventListener("ended", () => {
                this.displaySuggestions();
            }, {
                once: true,
            });

            if ($(this.element).hasClass("audioPlayer__modal--active")) {
                this.handleModal();
            }

            const remotePlayEl = document.querySelector('[mejs-remote-play="' + this.player.mejs.media.id + '"]');

            if (remotePlayEl) {
                $(remotePlayEl).click("click", () => {
                    this.player.mejs.play();
                });
            }

            const listElementInputs = this.element.querySelectorAll(".mejs__speed-selector-list li input");

            listElementInputs.forEach(function (input) {
                input.addEventListener('click', function (element) {
                    that.element.querySelector('.mejs__speed-button').style.setProperty('--content', `"${input.nextElementSibling.textContent}"`)
                });
            });
        }

        throttled(limit, callback) {
            var waiting = false;
            return function () {
                if (!waiting) {
                    callback.apply(this, arguments);
                    waiting = true;
                    setTimeout(function () {
                        waiting = false;
                    }, limit);
                }
            };
        }

        detectTouch() {
            return (("ontouchstart" in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0));
        }

        displayAudio(startPlayback = false) {
            //eslint-disable-next-line
            mejs.i18n.language("de"); // Setting German language
            //eslint-disable-next-line
            this.player.mejs = new MediaElementPlayer(this.player.audio, this.settings.mejs);

            $(this.element).removeClass("ended");

            if (startPlayback) {
                this.player.mejs.play();
            }

            // set duration in ms from attributes
            if (this.player.audio.dataset.durationMs &&
                this.player.audio.dataset.durationMs > 0) {
                var durationS = this.player.audio.dataset.durationMs / 1000;

                if (durationS > 0) {
                    var minutes = Math.floor(durationS / 60);
                    var seconds = Math.floor(durationS - 60 * minutes);
                    this.element.querySelector('.mejs__duration').innerText = minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");
                }
            }

            this.bindEvents();
        }


        displaySuggestions() {
            this.player.suggestions.removeClass("audioPlayer__suggestions--hide");
            $(this.element).addClass("ended");
            $(this.player.suggestions).find(".audioPlayer--replay").one("click", () => {
                this.player.suggestions.addClass("audioPlayer__suggestions--hide");
                this.displayAudio(true);
            });
        }

        handleModal() {
            this.player.modal = this.player.modal || $(this.element).closest(".audioTeaser__modal");
            this.player.playBtn = this.player.playBtn || $(this.element).find(".mejs__overlay-button");
            this.player.captions = this.player.captions || $(this.element).find(".mejs__captions-button");

            this.player.modal.on("shown.bs.modal", () => {
                this.player.playBtn.focus();
            }).on("hide.bs.modal", () => {
                this.player.mejs.pause();
                this.player.mejs.setCurrentTime(0);
                this.player.mejs.setVolume(1);
                this.player.mejs.setMuted(false);
            });
        }
    }

    function init() {
        $players = $("[data-js-audioplayer]");

        $.each($players, (i, element) => new AMAudioPlayer(element));
    }

    var $players;

    return {
        init: init,
    };

})();

export { AudioPlayer };
